export default __webpack_public_path__ + "static/media/gallery.afeff24a.jpg";